import { observer } from 'mobx-react-lite';
import styles from './index.module.scss';
import ClinicalEventForm from './ClinicalEventForm';
import { useClinicalEventsModal } from './Provider';
import classNames from 'classnames';
import { useParams } from 'react-router';
import { head } from 'lodash';
import useRtmEventsService from '../service';
import { formatTime } from '../../../../services/timeService';

const DrawerContent = ({ onChange }: { onChange?: (uuid: string) => void }) => {
  const {
    contextData: { clinicalEventUuid },
  } = useClinicalEventsModal();

  const { patientUuid = '' } = useParams<{ patientUuid: string }>();
  const { getEvent } = useRtmEventsService(patientUuid);
  const event = clinicalEventUuid ? getEvent(clinicalEventUuid) : null;
  const currentVersion = head(event?.versions);

  return (
    <div className={'flex flex-col h-full relative'}>
      <div className={styles.header}>
        <p className="flex items-center text-base font-semibold flex-wrap">
          {clinicalEventUuid ? 'Amend' : 'New'} event
          {currentVersion?.timestamp ? (
            <span
              className={classNames(
                'ml-1 font-normal text-neutrals-n-300 text-xs',
                styles.createdAt,
              )}
            >
              Created at · {formatTime(currentVersion?.timestamp)}
            </span>
          ) : null}
        </p>
      </div>
      <ClinicalEventForm onChange={onChange} newItem={!clinicalEventUuid} />
    </div>
  );
};

export default observer(DrawerContent);
